export default __webpack_public_path__ + "static/media/08_photo.8d4ce3e9.jpg";